<h3>Settings</h3>
<ul ngbNav #nav="ngbNav" class="nav-tabs" [(activeId)]="activeTab">
  <li [ngbNavItem]="2" *ngIf="hasNotificationPreferences || isEmployeePortal">
    <a ngbNavLink class="tab-title">Notifications</a>
    <ng-template ngbNavContent>
      <lib-notification-preferences></lib-notification-preferences>
    </ng-template>
  </li>
  <li [ngbNavItem]="3" *ngIf="canManageUsers && !isEmployeePortal">
    <a ngbNavLink class="tab-title">User Management</a>
    <ng-template ngbNavContent>
      <app-client-user-management></app-client-user-management>
    </ng-template>
  </li>
</ul>
<div [ngbNavOutlet]="nav"></div>
